document.addEventListener('DOMContentLoaded', function() {
  const firstNameField = document.getElementById('RegisterForm-FirstName');
  const lastNameField = document.getElementById('RegisterForm-LastName');
  const emailField = document.getElementById('RegisterForm-email');
  const passwordField = document.getElementById('RegisterForm-password');
  const confirmPasswordField = document.getElementById('RegisterForm-password-confirmation');
  const submitButton = document.getElementById('register-submit-button');
  const errorMessage = document.getElementById('password-match-error');

  // Solo ejecutar validación si estamos en la página de registro
  if (firstNameField && lastNameField && emailField && passwordField && confirmPasswordField && submitButton && errorMessage) {
    function isValidEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }

    function validateForm() {
      const firstName = firstNameField.value.trim();
      const lastName = lastNameField.value.trim();
      const email = emailField.value.trim();
      const password = passwordField.value;
      const confirmPassword = confirmPasswordField.value;

      let isValid = true;

      // Validar campos requeridos
      if (!firstName || !lastName || !email || !password || !confirmPassword) {
        isValid = false;
      }

      // Validar email
      if (email && !isValidEmail(email)) {
        isValid = false;
      }

      // Validar contraseñas
      if (confirmPassword && password !== confirmPassword) {
        errorMessage.style.display = 'block';
        isValid = false;
      } else if (confirmPassword && password === confirmPassword) {
        errorMessage.style.display = 'none';
      } else {
        errorMessage.style.display = 'none';
      }

      // Habilitar/deshabilitar botón
      if (isValid) {
        submitButton.disabled = false;
        submitButton.title = '';
        submitButton.classList.add('button-valid');
      } else {
        submitButton.disabled = true;
        submitButton.title = 'Completa todos los campos correctamente para continuar';
        submitButton.classList.remove('button-valid');
      }
    }

    // Agregar event listeners a todos los campos
    firstNameField.addEventListener('input', validateForm);
    lastNameField.addEventListener('input', validateForm);
    emailField.addEventListener('input', validateForm);
    passwordField.addEventListener('input', validateForm);
    confirmPasswordField.addEventListener('input', validateForm);

    // Validar inicialmente
    validateForm();
  }

  // Toggle password visibility - Funciona en cualquier página que tenga .password-toggle
  document.querySelectorAll('.password-toggle').forEach(button => {
    button.addEventListener('click', function() {
      const targetId = this.getAttribute('data-target');
      const input = document.getElementById(targetId);
      if (input) {
        const isPassword = input.type === 'password';
        input.type = isPassword ? 'text' : 'password';
        // Cambiar ícono
        const svg = this.querySelector('svg');
        if (isPassword) {
          // Cambiar a ícono de ojo abierto
          svg.innerHTML = '<path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z"></path><circle cx="12" cy="12" r="3"></circle>';
        } else {
          // Cambiar a ícono de ojo cerrado
          svg.innerHTML = '<path d="M9.88 9.88a3 3 0 1 0 4.24 4.24"></path><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68"></path><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61"></path><line x1="2" x2="22" y1="2" y2="22"></line>';
        }
      }
    });
    // Prevenir selección de texto
    button.addEventListener('mousedown', function(e) {
      e.preventDefault();
    });
    // Para accesibilidad con teclado
    button.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  // Validar inicialmente
  validateForm();
});